<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o ajuste de entrada de estoque de código <b>{{this.entry.code}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(entryStorageAdjustment) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_ENTRY_STORAGE_ADJUSTMENT_MUTATION,
          variables: {
            id: entryStorageAdjustment.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyEntryStorageAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            // this.deleteDialog = false;
            // console.log("del", this.$refs);
            // this.entry.id = response.data.destroyEntryStorageAdjustment.entryStorageAdjustment.id;
            this.$emit("entry-destroyed", entryStorageAdjustment);
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_ENTRY_STORAGE_ADJUSTMENT_MUTATION = gql `
  mutation($id: ID!) {
    destroyEntryStorageAdjustment(id: $id) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>